// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"945":"61fb70e4","1333":"0986a0ba","2525":"98f29caa","3690":"0089643e","4018":"98875e10","4178":"98f29caa","5515":"98875e10"}[chunkId] + ".chunk.css";
};